import React, { Fragment, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { orderReportsAction } from '../../redux/actions/orderActions';
import { useSearchParams } from 'react-router-dom';

const Filters = ({ page, setPage, dateFrom, dateTo, target_user }) => {


    const dispatch = useDispatch()

    const { user } = useSelector(state => state.verifyEmailStore);
    const { message } = useSelector(state => state.createReport)





    const [searchParams, setSearchParams] = useSearchParams();



    const [filter_count, setFilter_count] = useState(0);
    const [perPage, setPerPage] = useState('10');
    const [pmm_id, setpmm_id] = useState('');
    const [pm_id, setPm_id] = useState('');
    const [order_id, setOrder_id] = useState("");
    const [status, setStatus] = useState("");







    useEffect(() => {

        const query = {}

        if (pmm_id) query.pmm_id = pmm_id
        if (pm_id) query.pm_id = pm_id
        if (order_id) query.order_id = order_id
        if (perPage) query.perPage = perPage
        if (status) query.status = status

        query.page = page

        // 🚫 Do NOT include dates in URL
        setSearchParams(query)

        // ✅ Add dates only for API
        if (dateFrom) query.dateFrom = dateFrom
        if (dateTo) query.dateTo = dateTo
        if (target_user) query.target_user = target_user

        console.log(target_user)

        dispatch(orderReportsAction(query))

    }, [
        dateFrom,
        dateTo,
        perPage,
        status,
        page,
        pmm_id,
        pm_id,
        order_id,
        dispatch,
        message,
        setSearchParams,
        target_user
    ])




    useEffect(() => {

        setStatus(searchParams.get("status") || "")
        setPerPage(searchParams.get("perPage") || "10")
        setpmm_id(searchParams.get("pmm_id") || "")
        setPm_id(searchParams.get("pm_id") || "")
        setOrder_id(searchParams.get("order_id") || "")


    }, [searchParams, setPage])






    useEffect(() => {

        setFilter_count(0)

        if (pmm_id) {
            setFilter_count(prev => prev + 1)
        }
        if (pm_id) {
            setFilter_count(prev => prev + 1)
        }
        if (order_id) {
            setFilter_count(prev => prev + 1)
        }
        if (status) {
            setFilter_count(prev => prev + 1)
        }

    }, [pmm_id, pm_id, order_id, status])




    useEffect(() => {




        const Headerlinkks = document.querySelectorAll(".headerLinks");
        const subLinks = document.querySelectorAll(".subLinks");
        const element = document.getElementById("order-reports");


        Headerlinkks.forEach(el => el.classList.remove("activeHeaderLink"));
        subLinks.forEach(el => el.classList.remove("activeSubLink"));
        element?.classList.add("activeHeaderLink");


        document.title = `ALL ORDERS - Admin Panel`;

    }, []);



    return (
        <Fragment>
            <div className="bg-white p-[2vmax] shadow-sm rounded-xl border border-gray-100 mb-[2vmax]">
                <div className="flex items-center justify-between mb-[1.5vmax]">
                    <div className="flex items-center gap-[0.5vmax]">
                        <div className="w-[0.3vmax] h-[1.5vmax] bg-indigo-600 rounded-full"></div>
                        <h3 className="text-[1.2vmax] font-bold text-gray-700">Search Filters</h3>
                    </div>
                    
                    <div className="flex items-center gap-[1vmax]">
                        <span className='text-[0.9vmax] text-gray-500 font-medium' >Items per page:</span>
                        <div className="flex bg-gray-50 items-center border border-gray-200 p-[0.4vmax_0.8vmax] rounded-lg focus-within:border-indigo-400 transition-all">
                            <i className="fa-solid fa-list-ul text-gray-400 text-[0.9vmax]"></i>
                            <select 
                                className="pl-[0.5vmax] text-[0.95vmax] text-gray-600 outline-none bg-transparent cursor-pointer"
                                value={perPage}
                                onChange={(e) => {
                                    setPerPage(e.target.value)
                                    setPage(1)
                                }}
                            >
                                <option value="1">1</option>
                                <option value="5">5</option>
                                <option value="10">10</option>
                                <option value="20">20</option>
                            </select>
                        </div>
                    </div>
                </div>

                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 xl:grid-cols-5 gap-[1.2vmax]">
                    {/* Order ID */}
                    <div className="flex items-center bg-gray-50 border border-gray-200 p-[0.6vmax_1vmax] rounded-xl focus-within:border-indigo-400 focus-within:bg-white transition-all shadow-sm">
                        <i className="fa-solid fa-hashtag text-gray-400 text-[1vmax]"></i>
                        <input 
                            type="text" 
                            className="w-full pl-[0.8vmax] text-[0.95vmax] bg-transparent outline-none text-gray-700 placeholder-gray-400" 
                            placeholder="Order ID...."
                            value={order_id}
                            onChange={(e) => {
                                setOrder_id(e.target.value)
                                setPage(1)
                            }}
                        />
                    </div>

                    {/* Status Select */}
                    <div className="flex items-center bg-gray-50 border border-gray-200 p-[0.6vmax_1vmax] rounded-xl focus-within:border-indigo-400 focus-within:bg-white transition-all shadow-sm">
                        <i className="fa-solid fa-circle-dot text-indigo-500 text-[0.8vmax]"></i>
                        <select 
                            className="w-full pl-[0.8vmax] text-[0.95vmax] bg-transparent outline-none text-gray-700 font-bold cursor-pointer"
                            value={status}
                            onChange={(e) => {
                                setStatus(e.target.value)
                                setPage(1)
                            }}
                        >
                            <option value="">Status</option>
                            <option value="RESOLVED">Resolved</option>
                            <option value="PENDING">Pending</option>
                            <option value="UNDER_REVIEW">Under Review</option>
                            <option value="REJECTED">Rejected</option>
                        </select>
                    </div>

                    {/* Seller ID Filter */}
                    {(user?.role !== 'PMM' && user?.role !== "PM") &&
                        <div className="flex items-center bg-gray-50 border border-gray-200 p-[0.6vmax_1vmax] rounded-xl focus-within:border-indigo-400 focus-within:bg-white transition-all shadow-sm">
                            <i className="fa-regular fa-user text-gray-400 text-[1vmax]"></i>
                            <input 
                                type="text" 
                                className="w-full pl-[0.8vmax] text-[0.95vmax] bg-transparent outline-none text-gray-700 placeholder-gray-400" 
                                placeholder="Seller ID...."
                                value={pmm_id}
                                onChange={(e) => {
                                    setpmm_id(e.target.value)
                                    setPage(1)
                                }}
                            />
                        </div>
                    }

                    {/* PM ID Filter */}
                    {(user?.role !== 'PMM' && user?.role !== "PM") &&
                        <div className="flex items-center bg-gray-50 border border-gray-200 p-[0.6vmax_1vmax] rounded-xl focus-within:border-indigo-400 focus-within:bg-white transition-all shadow-sm">
                            <i className="fa-solid fa-user-tie text-gray-400 text-[1vmax]"></i>
                            <input 
                                type="text" 
                                className="w-full pl-[0.8vmax] text-[0.95vmax] bg-transparent outline-none text-gray-700 placeholder-gray-400" 
                                placeholder="Pm ID...."
                                value={pm_id}
                                onChange={(e) => {
                                    setPm_id(e.target.value)
                                    setPage(1)
                                }}
                            />
                        </div>
                    }

                    {/* Clear Filters Button */}
                    <button 
                        onClick={() => {
                            setpmm_id("")
                            setPm_id("")
                            setOrder_id("")
                            setStatus("")
                        }}
                        className="flex items-center justify-center gap-2 px-4 py-2 bg-white border border-gray-200 rounded-xl text-[0.95vmax] font-bold text-gray-600 hover:bg-red-50 hover:text-red-600 hover:border-red-100 transition-all shadow-sm group"
                    >
                        <i className="fa-solid fa-rotate-right text-xs group-hover:rotate-180 transition-transform duration-500"></i>
                        Clear ({filter_count})
                    </button>
                </div>
            </div>
        </Fragment>
    )
}

export default Filters